// GENERATED from ez-tree preset "Ash Small" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const AshSmall_KIND_ID = "ezTree_AshSmall";

export const AshSmallKind = new SceneryKindDef({
	id: "ezTree_AshSmall",
	name: "Ash Small",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 2,
		"branchAngle1": 48,
		"branchAngle2": 75,
		"branchChildren0": 10,
		"branchChildren1": 3,
		"branchChildren2": 3,
		"branchGnarliness0": 0.11,
		"branchGnarliness1": 0.09,
		"branchGnarliness2": 0.05,
		"branchGnarliness3": 0.09,
		"branchLength0": 23.87,
		"branchLength1": 18,
		"branchLength2": 5.59,
		"branchLength3": 4.6,
		"branchRadius0": 0.81,
		"branchRadius1": 0.56,
		"branchRadius2": 0.76,
		"branchSections2": 10,
		"branchSections3": 10,
		"branchStart1": 0.53,
		"branchStart2": 0.33,
		"branchStart3": 0,
		"branchTwist0": 0.3,
		"branchTwist1": -0.07,
		"leafCount": 30,
		"leafSize": 2.05,
		"leafSizeVariance": 0.717,
		"leafAngle": 55,
		"leafType": "ash",
		"barkTint": 13552830,
		"barkTextureScaleX": 0.5,
		"barkTextureScaleY": 5,
		"targetHeight": 12.15,
	},
	footprintRadiusRatio: 0.499,
});
